module.exports = __webpack_public_path__ + "static/media/S2N7-2.19f314a0.svg";